import * as React from 'react';

const FilterSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 20h1v-3H9v3zm-1-4v2H4v1h4v2h3v-2h9v-1h-9v-2H8zM18 13.5h1v-3h-1v3zm-1-4v2H4v1h13v2h3v-5h-3zM9 7h1V4H9v3zM8 3v2H4v1h4v2h3V6h9V5h-9V3H8z"
        />
    </svg>
);

FilterSvg.displayName = 'FilterSvg';
export default FilterSvg;
